export default {
  DesktopMinWidth: '951px',
  TabletMaxWidth: '950px',
  SuperWide: '1600px',
};
